import { render, staticRenderFns } from "./ChooseGoods.vue?vue&type=template&id=1d3a0a50&scoped=true&"
import script from "./ChooseGoods.vue?vue&type=script&lang=js&"
export * from "./ChooseGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a0a50",
  null
  
)

export default component.exports